import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

interface EnrollmentCardThemeProps {
  footer: JSX.Element | null;
  hasConfirmedProposal: boolean;
}
const styles: ComponentStylesProps<EnrollmentCardThemeProps> = {
  enrollmentCard: ({ hasConfirmedProposal }) => ({
    position: 'relative',
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    padding: hasConfirmedProposal ? '2rem 3.2rem' : '2rem 3.2rem 3.2rem',
    marginBottom: '3.6rem',
    '&:last-of-type': {
      marginBottom: '0',
    },
  }),
  cardHeader: ({ footer }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: footer ? '3.6rem' : '3rem',
    paddingBottom: !footer && '3rem',
    borderBottom: !footer && `0.1rem solid ${colors.neutral[300]}`,
  }),
  leftHeaderSection: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' },
  rightHeaderSection: { position: 'relative' },
  effectiveDateTitle: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 500 },
    letterSpacing: '0.02em',
    color: colors.neutral[500],
    textTransform: 'uppercase',
    margin: 0,
    marginBottom: '0.5rem',
  },
  effectiveDateValue: {
    font: {
      size: '2.4rem',
      lineHeight: '3.2rem',
      weight: 700,
    },
    letterSpacing: '0.02em',
    margin: 0,
    color: colors.neutral[900],
    minWidth: '13.2rem',
    marginRight: '2rem',
  },
  ratesTitle: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 500 },
    letterSpacing: '0.02em',
    color: colors.neutral[700],
    textTransform: 'uppercase',
    margin: 0,
    marginBottom: '3rem',
  },
  stageTagContainer: {
    paddingBottom: '0.3rem',
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
  },
  continueButton: {
    marginLeft: '2rem',
  },
  portfoliosList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '5rem',
  },
  proposalInfo: ({ footer }) => ({
    borderBottom: !footer && `0.1rem solid ${colors.neutral[300]}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }),

  confirmationButton: {
    margin: '0 auto 3rem',
  },
  productLineSection: {
    width: '100%',
  },
  cardsWrapperOneProduct: {
    display: 'grid',
    gridTemplateColumns: 'repeat( auto-fit, minmax(280px, 1fr) )',
    gap: '3rem',
  },
  cardsWrapperWithoutRenewal: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
  cardsWrapperMultiProducts: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '3rem',
  },
  productLineTitle: {
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    width: '100%',
    paddingBottom: '2rem',
    marginBottom: '3rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
